export const railStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 0,
  padding: '8px 8px 4px',
};
